import { useMutation as t } from "react-query";
import { useEnvironment as r } from "../../../../../features/common/hooks/environment/useEnvironment.js";
import { ScopeAdapter as o } from "../../../../../features/api/models/scope/scope.adapter.js";
import { getAdapter as a } from "../../../../../features/api/adapter.js";
function m() {
  const {
    backendBaseUrl: s
  } = r();
  return t(
    async (e) => (await fetch(`${s}/shop-service/availability/daily/`, {
      method: "post",
      body: JSON.stringify({
        service_type: e.serviceType,
        scope: a(o).serialize(e.scope),
        address: e.address
      })
    })).json()
  );
}
export {
  m as default
};
//# sourceMappingURL=useRestaurantDays.js.map
